import { useCallback } from 'react';
import type ExploreEventData from '@alltrails/explore-service/types/ExploreEventData';
import useMap from '@alltrails/maps/hooks/useMap';

export function useOnNewBoundingBox() {
  const map = useMap();

  const onNewBoundingBox = useCallback(
    boundingBox => {
      // pass the bounding box to the event handlers, as mapbox's fitBounds does not yield the exact same bounding box
      const eventData: ExploreEventData = { boundingBox, mapRotation: 0 };
      map?.fitBounds(
        [
          [boundingBox.bottomLeft.lng, boundingBox.bottomLeft.lat],
          [boundingBox.topRight.lng, boundingBox.topRight.lat]
        ],
        {},
        eventData
      );
    },
    [map]
  );

  return onNewBoundingBox;
}
